export const getSeriesName = (
  shortTitle?: string,
  Title?: string,
  transactionDate?: string
): string => {
  if (shortTitle && shortTitle.length > 0) {
    return shortTitle.trim() + (transactionDate ? ` ${transactionDate}` : '');
  }
  if (Title && Title.length > 0) {
    return Title + (transactionDate ?? '');
  }
  return '';
};
